<template>
  <div
    v-if="toastVisible"
    class="toast"
    :class="{
      'toast--success': type === 'success',
      'toast--warning': type === 'warning',
      'toast--error': type === 'error',
    }"
  >
    <div class="toast-content">
      <div class="toast-heading">
        <div class="header">
          <b>{{ header }}</b>
        </div>
        <div
          class="close"
          @click="close"
        >
          <fn-icon
            icon="cross"
            bold
          />
        </div>
      </div>
      <div class="toast-text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
    closeAfterMs: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: 'success',
      options: ['success', 'warning', 'error'],
    },
    header: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  data: () => ({
    visible: false,
  }),
  computed: {
    toastVisible() {
      return this.show && this.visible;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.visible = true;
      }

      if (val && this.closeAfterMs) {
        setTimeout(() => {
          this.close();
        }, this.closeAfterMs);
      }

      if (!val) {
        this.visible = false;
      }
    },
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.toast {
  border-radius: map-get($border-radiuses, 'xl');

  &--success {
    background-color: palette(background, green);
    color: $color-brand-fnmz-green;
  }

  &--warning {
    background-color: palette(background, orange);
    color: palette(orientation, orange);
  }

  &--error {
    background-color: palette(background, red);
    color: palette(red, dark);
  }

  .toast-content {
    padding: $pad;

    .toast-heading {
      display: flex;
      justify-content: space-between;
      margin-bottom: math.div($pad, 4);

      .header {
        font-size: map-get($font-sizes, l);
      }

      .close {
        margin-left: $pad;
        cursor: pointer;
      }
    }
  }
}
</style>
